const { REACT_APP_AZURE_MAP_KEY } = process.env;

export const geoCodeAddress = async address => {
  const addressFormatted = encodeURIComponent(
    `${address.address1} ${address.city}, ${address.state} ${
      address.postalCode
    }`
  );

  const url = `https://atlas.microsoft.com/search/address/json?subscription-key=${REACT_APP_AZURE_MAP_KEY}&api-version=1&query=${addressFormatted}`;

  return await fetch(url)
    .then(response => {
      return response.json();
    })
    .then(
      data =>
        new Promise(function(resolve, reject) {
          if (data.results && data.results.length > 0) {
            resolve(data.results[0]);
          } else {
            reject();
          }
        })
    )
    .catch(() => {
      return Promise.reject('Geocode Address failed');
    });
};

export const searchByAddress = async address => {
  const addressFormatted = encodeURIComponent(`${address}`);

  const url = `https://atlas.microsoft.com/search/address/json?subscription-key=${REACT_APP_AZURE_MAP_KEY}&api-version=1&query=${addressFormatted}`;

  return await fetch(url)
    .then(response => {
      return response.json();
    })
    .then(
      data =>
        new Promise(function(resolve, reject) {
          if (data.results && data.results.length > 0) {
            //loop through and only return type "Point Address"
            const addresses = data.results.filter(
              address => address.type === 'Point Address'
            );
            const mappedAddresses = addresses.map(a => {
              const address = a.address;
              return {
                ...address,
                streetNameAndNumber: `${address.streetNumber} ${
                  address.streetName.split(',')[0]
                }`,
                municipality: address.municipality.split(',')[0]
              };
            });
            resolve(mappedAddresses);
          } else {
            reject();
          }
        })
    )
    .catch(() => {
      return Promise.reject('Address lookup failed');
    });
};
